import * as React from "react";
import { MultiSelectOptionApiModel } from "../apiModels/MultiSelectOptionApiModel";
import { RioForEach, RioIfFunc, RioIf, RioUnsafe, RioResources } from "rio.react.all";

interface IQuickSearchMultiSelectProps {
    onChange: (values: Array<MultiSelectOptionApiModel>) => void;
    potentialOptions: Array<MultiSelectOptionApiModel>;
    minCharactersBeforeSearch?: number;
    clearInputAfterSelection?: boolean;
    className?: string
}

interface IQuickSearchMultiSelectState {
    currentValue: string;
    selectedValues: Array<MultiSelectOptionApiModel>;
    choosableValues: Array<MultiSelectOptionApiModel>;
}

export class QuickSearchMultiSelect extends React.Component<IQuickSearchMultiSelectProps, IQuickSearchMultiSelectState> {
    constructor(props: Readonly<IQuickSearchMultiSelectProps>) {
        super(props);

        this.state = {
            currentValue: "",
            selectedValues: [],
            choosableValues: []
        };
    }

    render() {

        return (
            <div className={ "quickSearchMultiSelectWrapper " + this.props.className }>
                <div>
                    <input type="text" value={this.state.currentValue} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onInputValueChanged(e)}></input>
                </div>
                <div className="multiSelectedValues">
                    <RioForEach items={this.state.selectedValues} perform={(selectedValue: MultiSelectOptionApiModel, index) => {
                        return (
                            <div key={"select" + selectedValue.text + index} className="multiSelectChosenOption">
                                <button type="button" className="multiSelectRemoveItemButton" onClick={() => this.removeSelectedItem(selectedValue)}><RioUnsafe html={RioResources.find("Close").image} /></button> <span className="multiSelectChosenLabel">{selectedValue.text}</span>
                            </div>
                        );
                    }} />

                </div>
                <RioIf condition={!!this.state.choosableValues} then={
                    <div className="multiSelectPotentialOptionWrapper">
                        <RioForEach items={this.state.choosableValues} perform={(choosableValue: MultiSelectOptionApiModel, index) => {
                            return (
                                <div key={"choose" + choosableValue.text + index} className="multiSelectPotentialOption" >
                                    <input type="checkbox" checked={this.ArrayContains(this.state.selectedValues, choosableValue.value)} onChange={() => this.optionPicked(choosableValue)} disabled={choosableValue.disabled} /> <span>{choosableValue.text}</span>
                                </div>
                            );
                        }} />
                    </div>

                } />
            </div>

        );
    }

    componentDidUpdate() {
       
    }

    optionPicked(choosableValue: MultiSelectOptionApiModel) {
        if (this.ArrayContains(this.state.selectedValues, choosableValue.value)) {
            const newSelectedValues = this.state.selectedValues.filter(sv => sv.value.toLowerCase() !== choosableValue.value.toLowerCase());
            let newChoosableValues = this.state.choosableValues;
            newChoosableValues.push(choosableValue);
            newChoosableValues = newChoosableValues.sort();
            this.setState({
                selectedValues: newSelectedValues,
                choosableValues: newChoosableValues
            }, () => this.props.onChange(this.state.selectedValues));
        } else {
            const newSelectedValues = this.state.selectedValues;
            newSelectedValues.push(choosableValue);
            const newChoosableValues = this.state.choosableValues.filter(cv => cv.value.toLowerCase() !== choosableValue.value.toLowerCase());
            this.setState({
                selectedValues: newSelectedValues,
                choosableValues: newChoosableValues
            }, () => this.props.onChange(this.state.selectedValues));
        }
        if (!!this.props.clearInputAfterSelection) {
            this.clearInputs();
        }
        
    }
    onInputValueChanged(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.currentTarget.value === "") {
            this.clearInputs();
        } else if (!!this.props.minCharactersBeforeSearch && e.currentTarget.value.length < this.props.minCharactersBeforeSearch) {
            this.setState({
                currentValue: e.target.value,
                choosableValues: []
            });
        }else {
            const options = this.props.potentialOptions
                .filter(o => !this.ArrayContains(this.state.selectedValues, o.text))
                .filter(o => o.text.toLowerCase().includes(e.currentTarget.value.toLowerCase()))
                .sort(function (a, b) {
                    if (a.text > b.text) {
                        return 1;
                    } else {
                        return -1;
                    }
            });

            this.setState({
                currentValue: e.target.value,
                choosableValues: options
            });
        }
    }

    removeSelectedItem(selectedValue: MultiSelectOptionApiModel) {
        const newSelectedValues = this.state.selectedValues.filter(v => v !== selectedValue);
        let newChoosableValues = this.state.choosableValues;

        if (!!this.state.currentValue && selectedValue.text.toLowerCase().includes(this.state.currentValue.toLowerCase())) {
            newChoosableValues.push(selectedValue);
            newChoosableValues = newChoosableValues.sort(function (a, b) {
                if (a.text > b.text) {
                    return 1;
                } else {
                    return -1;
                }
            });
        }

        this.setState({
            selectedValues: newSelectedValues,
            choosableValues: newChoosableValues
        }, () => this.props.onChange(this.state.selectedValues));
    }

    clearInputs() {
        this.setState({
            currentValue: "",
            choosableValues: []
        });
    }

    ArrayContains(itemArray: Array<MultiSelectOptionApiModel>, valueToCheck: string): boolean {
        for (let i = 0; i < itemArray.length; i++) {
            if (itemArray[i].text.toLowerCase() === valueToCheck.toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    
}
